module.exports = {
    merchantName: "Golden Valley",
    merchantDomain: "https://goldenvalleychinesebromley.co.uk",  // Need correct! project will upload dist to targer domain file in Plesk.
    merchantMenuUrl: "/menu-golden-valley", // target merchant's menu url in alleatapp.com
    // when you building files, fill this info, dont push these to github.
    pleskUsername: 'root',
    pleskPs: '3uyo$9!Ws9',
}
